module.exports = __webpack_public_path__ + "static/img/collection2.2f12656.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/merchant-plus/collection2.jpg
// module id = KdqL
// module chunks = 1